"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _1 = require("./");
var inversify_1 = require("inversify");
var Root = /** @class */ (function () {
    function Root(blogs, blogPosts, comments, files, tags, statuses) {
        this.blogs = blogs;
        this.blogPosts = blogPosts;
        this.comments = comments;
        this.files = files;
        this.tags = tags;
        this.statuses = statuses;
    }
    var _a, _b, _c, _d, _e, _f;
    Root = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.BlogClient)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.BlogPostClient)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.BlogPostCommentClient)),
        tslib_1.__param(3, inversify_1.inject(_1.TYPES.BlogPostFilesClient)),
        tslib_1.__param(4, inversify_1.inject(_1.TYPES.BlogTagClient)),
        tslib_1.__param(5, inversify_1.inject(_1.TYPES.BlogPostStatusClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.BlogClient !== "undefined" && _1.BlogClient) === "function" ? _a : Object, typeof (_b = typeof _1.BlogPostClient !== "undefined" && _1.BlogPostClient) === "function" ? _b : Object, typeof (_c = typeof _1.BlogPostCommentClient !== "undefined" && _1.BlogPostCommentClient) === "function" ? _c : Object, typeof (_d = typeof _1.BlogPostFilesClient !== "undefined" && _1.BlogPostFilesClient) === "function" ? _d : Object, typeof (_e = typeof _1.BlogTagClient !== "undefined" && _1.BlogTagClient) === "function" ? _e : Object, typeof (_f = typeof _1.BlogPostStatusClient !== "undefined" && _1.BlogPostStatusClient) === "function" ? _f : Object])
    ], Root);
    return Root;
}());
exports.Root = Root;
